export const edit = document.querySelector('[data-template="icon-edit"]').innerHTML;
export const heart = document.querySelector('[data-template="icon-heart"]').innerHTML;
export const heartFilled = document.querySelector('[data-template="icon-heart-filled"]').innerHTML;
export const remove = document.querySelector('[data-template="icon-remove"]').innerHTML;
export const cartPlus = document.querySelector('[data-template="icon-cart-plus"]').innerHTML;
export const cartMinus = document.querySelector('[data-template="icon-cart-minus"]').innerHTML;

export default {
  edit,
  heart,
  heartFilled,
  remove,
  cartPlus,
  cartMinus,
};
